import { Badge, Tooltip } from '@radix-ui/themes'
import { LuCrown } from 'react-icons/lu'

export const SuperAdminBadge = () => (
  <Tooltip content="Super Admin Only">
    <Badge color="iris">
      <LuCrown size={18} />
    </Badge>
  </Tooltip>
)
